import * as echarts from 'echarts'

/**
 * 绘制图表
 */
export function drewcav(context, title, data, levlist, type) {
  let xdata = []
  let series = []
  let legend = []
  let colorlist = [['rgba(255, 255, 0,1)'], ['rgba(20, 255, 20,1)'], ['rgba(247, 20, 20,1)'], ['#85f67a', ''], ['#85f67a', ''], ['#85f67a', ''], ['rgba(255, 200, 0,1)'], ['rgba(20, 200, 20,1)'], ['rgba(200, 20, 20,1)']]
  for (let i = 1; i < title.length; i++) {
    series.push(
      {
        name: title[i],
        type: type,
        barWidth: '10px',
        itemStyle: {
          normal: {
            color: function (params) {
              let color = ""
              if (levlist) {

                if (title[i] === '电气火灾' || title[i] === '电气老化') {
                  if (levlist[(params.dataIndex)][1] === '1') {
                    color = "rgba(20, 255, 20,1)"
                  } else if (levlist[(params.dataIndex)][1] === '2') {
                    color = "rgba(255, 255, 0,1)"
                  } else if (levlist[(params.dataIndex)][1] === '3') {
                    color = "rgba(255, 153, 0,1)"
                  } else if (levlist[(params.dataIndex)][1] === '4') {
                    color = "rgba(247, 20, 20,1)"
                  }
                } else if (title[i].indexOf('A相') !== -1) {
                  color = 'rgb(0,128,0)'
                } else if (title[i].indexOf('B相') !== -1) {
                  color = 'rgb(255,165,0)'
                } else if (title[i].indexOf('C相') !== -1) {
                  color = 'rgb(255,0,0)'
                } else {
                  color = colorlist[i - 1][0]
                }

              } else {
                color = colorlist[i - 1][0]
              }
              return color

            },
            barBorderRadius: 11,
          }
        },
        lineStyle: {
          normal: {
            color: function () {
              let color = ""
              color = colorlist[i - 1][0]
              return color
            },
          }
        },
        data: []
      },
    )
    legend.push(title[i])
  }
  for (let i = 0; i < data.length; i++) {
    xdata.push(data[i][0])

    for (let j = 1; j < data[i].length; j++) {

      series[j - 1].data.push(data[i][j])
    }
  }

  let myChart = context.$echarts.init(document.getElementById('analyesCav'));
  myChart.clear()
  let option = {
    tooltip: {
      trigger: 'axis',
      axisPointer: { // 坐标轴指示器，坐标轴触发有效
        type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
      }
    },
    legend: {
      data: legend
    },
    grid: {
      right: '5%',
      bottom: '3%',
      left: '6%',
      top: '20px',
      containLabel: true
    },
    xAxis: [{
      type: 'category',
      data: xdata,
      axisLine: {
        lineStyle: {
          color: '#0B4CA9'
        }
      },
      axisTick: {
        show: false,
      },
      axisLabel: {
        show: true,
        textStyle: {
          color: "#000",
          fontSize: 12,
        },
      },
    }],
    yAxis: [{
      type: 'value',
      nameTextStyle: {
        color: '#000'
      },
      position: 'left',
      axisLine: {
        lineStyle: {
          color: '#0B4CA9'
        }
      },
      splitLine: {
        show: false,
        lineStyle: {
          color: "#0B4CA9",
        }

      },
      axisLabel: {
        color: '#000',
        fontSize: 12,
      }
    }],
    series: series
  };
  myChart.setOption(option, true);

  window.onresize = myChart.resize;
}

/**
 * 绘制第二个图表
 */
export function drewcav2(context, title, data) {
  let xdata = []
  let ydata = []
  for (let i = 0; i < data.length; i++) {
    xdata.push(data[i][0])
    ydata.push(data[i][1])
  }

  let colorlist = [['#248ff7', '#6851f1'], ['#febe13', '#65e5dd'], ['#f071ff', '#85f67a']]
  let myChart = context.$echarts.init(document.getElementById("analyesCav"));
  myChart.clear()
  let option = {
    tooltip: {
      trigger: 'axis',
      axisPointer: { // 坐标轴指示器，坐标轴触发有效
        type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
      }
    },
    "dataZoom": [{
      "show": true,
      "height": 12,
      "xAxisIndex": [
        0
      ],
      bottom: '6%',
      "start": 10,
      "end": 90,
      handleIcon: 'path://M306.1,413c0,2.2-1.8,4-4,4h-59.8c-2.2,0-4-1.8-4-4V200.8c0-2.2,1.8-4,4-4h59.8c2.2,0,4,1.8,4,4V413z',
      handleSize: '110%',
      handleStyle: {
        color: "#d3dee5",

      },
      textStyle: {
        color: "#000"
      },
      borderColor: "#90979c"
    }, {
      "type": "inside",
      "show": true,
      "height": 20,
      "start": 1,
      "end": 35
    }],
    grid: {
      right: '10%',
      bottom: '13%',
      left: '6%',
      top: '20px',
      containLabel: true
    },
    xAxis: [{
      type: 'category',
      data: xdata,
      axisLine: {
        lineStyle: {
          color: '#0B4CA9'
        }
      },
      axisTick: {
        show: false,
      },
      axisLabel: {
        show: true,
        textStyle: {
          color: "#000",
          fontSize: 12,
        },
      },
    }],
    yAxis: [{
      type: 'value',

      nameTextStyle: {
        color: '#000'
      },
      position: 'left',
      axisLine: {
        lineStyle: {
          color: '#0B4CA9'
        }
      },
      splitLine: {
        show: false,
        lineStyle: {
          color: "#0B4CA9",
        }

      },
      axisLabel: {
        color: '#000',
        fontSize: 12,
      }
    }],
    series: {
      name: title[1],
      type: 'line',

      itemStyle: {
        normal: {
          color: "#19AF23",
          barBorderRadius: 11,
        }
      },
      data: ydata
    },
  };
  myChart.setOption(option, true);

  window.onresize = myChart.resize;
}

/**
 * 获取趋势图表
 */
export function gettrendCav(context) {
  let myChart = context.$echarts.init(document.getElementById('trendCav'));
  let option = {
    color: ['#80FFA5', '#00DDFF', '#37A2FF', '#FF0087', '#FFBF00'],
    tooltip: {
      trigger: 'axis'
    },
    legend: {
      data: ['Email', 'Union Ads', 'Video Ads', 'Direct', 'Search Engine']
    },
    grid: {
      left: '3%',
      right: '4%',
      bottom: '3%',
      containLabel: true
    },
    toolbox: {
      feature: {
        saveAsImage: {}
      }
    },
    xAxis: {
      type: 'category',
      boundaryGap: false,
      data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']
    },
    yAxis: {
      type: 'value'
    },
    series: [
      {
        name: 'Email',
        type: 'line',
        stack: 'Total',
        data: [120, 132, 101, 134, 90, 230, 210]
      },
      {
        name: 'Union Ads',
        type: 'line',
        stack: 'Total',
        data: [220, 182, 191, 234, 290, 330, 310]
      },
      {
        name: 'Video Ads',
        type: 'line',
        stack: 'Total',
        data: [150, 232, 201, 154, 190, 330, 410]
      },
      {
        name: 'Direct',
        type: 'line',
        stack: 'Total',
        data: [320, 332, 301, 334, 390, 330, 320]
      },
      {
        name: 'Search Engine',
        type: 'line',
        stack: 'Total',
        data: [820, 932, 901, 934, 1290, 1330, 1320]
      }
    ]
  };
  myChart.setOption(option, true);

  window.onresize = myChart.resize;
}

/**
 * 获取风险图表
 */
export function getriskCav(context, data) {
  let arrdata = []
  for (let i = 0; i < data.length; i++) {
    arrdata.push({ value: data[i].count, name: data[i].alertLevelName })
  }
  let myChart = context.$echarts.init(document.getElementById('riskCav'));
  let option = {
    color: ['#80FFA5', '#00DDFF', '#37A2FF', '#FF0087', '#FFBF00'],
    tooltip: {
      trigger: 'item'
    },

    series: [
      {
        name: '隐患类别',
        type: 'pie',
        radius: ['40%', '80%'],
        avoidLabelOverlap: false,
        itemStyle: {
          borderRadius: 10,
          borderColor: '#fff',
          borderWidth: 2
        },
        label: {
          show: false,

        },

        labelLine: {
          show: false
        },
        data: arrdata
      }
    ]
  };
  myChart.setOption(option, true);

  window.onresize = myChart.resize;
}